<template>
    <div class="about-us-box">
        <div class="top">
            <img class="bg-img" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/ss-live-bg.png">
            <div class="play-box">
                <img class="icon-play" :src="playIcon" @click="play" @touchstart="isHover = true" @touchend="isHover = false">
            </div>
            <transition>
            <div class="video-box" v-show="isShow">
                <div class="video-content">
                    <!-- <img class="icon-video-close" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/common/icon-video-close.png" @click="close"> -->
                    <video webkit-playsinline="playsinline" playsinline="playsinline" x5-playsinline="playsinline" x5-video-player-type="h5"  x-webkit-airplay="allow" controls class="video"  src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-web/video/%E6%9C%AA%E6%9D%A5%E9%AD%94%E6%B3%95%E6%A0%A13%E5%88%86%E9%92%9F%E4%B8%9A%E5%8A%A1%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%91.mp4" ref="videoBox"></video>
                </div>
            </div>
        </transition>    
        </div>
        <div class="content-box">
            <div class="contetn-item" v-for="(item, index) in aboutUs" :key="index">
                <section-title :main="item.main" :sub="item.sub"></section-title>
                <aboutContent :list="item.list"></aboutContent>
            </div>
        </div>
    </div>
</template>
<script>
import aboutContent from './components/about-content'
import { aboutUs } from '@/const'
export default {
    data () {
        return {
            aboutUs: aboutUs,
            isShow: false,
            isHover: false
        }
    },
    computed: {
        playIcon () {
            return this.isHover ? 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/play-hover.png' : 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/icon-play.png'
        }
    },
    components: { aboutContent },
    methods: {
        play () {
            this.isShow = true
            const myVideo = this.$refs.videoBox
            myVideo.addEventListener('ended', this.close, false)
            myVideo.play()
        },
        close () {
            const myVideo = this.$refs.videoBox
            myVideo.removeEventListener('ended', this.close, false)
            this.isShow = false
            this.$refs.videoBox.pause()
        }
    }
}
</script>
<style lang="scss" scoped>
.about-us-box{
    .top{
        position: relative;
        .bg-img{
            width: 100%;
        }
        .play-box{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .icon-play{
                width: 74px;
                height: 29px;
            }
        }
        .video-box{
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0px;
            left: 0px;
            background: rgba(0,0,0,0.5);
            z-index: 200;
            .video-content{
                position: absolute;
                width: 100%;
                top: 0px;
                left: 0;
                .icon-video-close{
                    width: 38px;
                    height: 38px;
                    position: absolute;
                    right: 10px;
                    top: 10px;
                    z-index: 201;
                }
                .video{
                    width: 100%;
                    height: 211px;
                }
            }
        }
        .v-enter,.v-leave-to{
            opacity: 0;
        }
        .v-enter-to,.v-leave{
            opacity: 1;
        }
        .v-enter-active,.v-leave-active{
            transition: all 0.6s;
        }
    }
}
</style>